<div class="q-chip" [class]="'q-chip--' + color">
  {{ text }}
</div>
